import * as React from "react";
import { Tooltip } from "antd";

interface TooltipHeaderCellProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  tooltip?: string;
}

const TooltipHeaderCell = ({
  tooltip,
  children,
  ...restProps
}: TooltipHeaderCellProps) => (
  <Tooltip title={tooltip}>
    <th {...restProps}>{children}</th>
  </Tooltip>
);

export default TooltipHeaderCell;
